import { render } from "./OrderDetail.vue?vue&type=template&id=2fa54d9e"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__